var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"r-radio",class:{ checked: _vm.isChecked }},[_c('input',{ref:"input",staticClass:"r-radio__input",attrs:{"id":_vm.id,"type":"radio"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_c('div',{staticClass:"r-radio__status"}),_c('r-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }